import { useConditionFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts';

export const useResetConditionErrors = () => {
  const { resetErrorsFromFieldPath } = useQueryErrorStateContext();
  const fieldPath = useConditionFieldPath();
  return () => resetErrorsFromFieldPath(fieldPath);
};
